export default {
  title: 'Perfil',
  fields: {
    name: {
      label: 'Nombre',
      placeholder: 'Introduce el nombre del restaurante',
    },
    short_name: {
      label: 'Nombre corto',
      placeholder: 'Introduce el nombre corto del restaurante',
      tooltip:
        'A veces el nombre predeterminado del restaurante es muy largo o contiene información secundaria, por lo que en algunos casos (p. ej. para notificaciones más cortas) se necesita una versión abreviada del nombre',
    },
    phone_number: {
      label: 'Número de teléfono',
      placeholder: 'Ingrese el número de teléfono del restaurante',
    },
    email: {
      label: 'Correo electrónico',
      placeholder: 'Ingrese el correo electrónico del restaurante',
    },
    slug: {
      label: 'Slug',
      placeholder: 'Slug de la marca',
    },
    language: {
      label: 'Idioma',
      placeholder: 'Usar el predeterminado del grupo',
      tooltip:
        'El idioma que ven los clientes en la tienda online de este restaurante, y el predeterminado para su personal. Déjalo vacío para seguir el idioma de la marca. El personal puede elegir su propio idioma para su vista.',
    },
    sms_name: {
      label: 'Nombre SMS',
      placeholder: 'Nombre visible en SMS',
    },
    instagram_link: {
      label: 'Enlace de Instagram',
      placeholder: 'Ingrese el enlace de Instagram del restaurante',
    },
    website_link: {
      label: 'Enlace del sitio web',
      placeholder: 'Ingrese el enlace del sitio web del restaurante',
    },
    impressum_link: {
      label: 'Enlace de Impressum',
      placeholder: 'Ingrese el enlace de Impressum del restaurante',
    },
    timezone: {
      label: 'Zona horaria',
      placeholder: 'Buscar ciudad o zona horaria',
      tooltip:
        'La zona horaria en la que opera este restaurante. Determina las marcas de tiempo de los pedidos, el horario de apertura y los turnos de pedidos programados. Se estableció a partir de la dirección del restaurante al crearlo — corrígela aquí si es incorrecta.',
    },
    time_format: {
      label: 'Formato de hora',
      placeholder: 'Usar el predeterminado del país',
      tooltip:
        'Cómo se muestran las horas a tu equipo, en el panel y el portal de pedidos. Déjalo vacío para seguir la convención de la región del restaurante.',
      options: {
        '12h': '12 horas (5:30 pm)',
        '24h': '24 horas (17:30)',
      },
    },
    primary_color: {
      label: 'Color principal',
    },
    restaurant_type: {
      label: 'Tipo de restaurante y modelo de servicio',
    },
    cuisine_types: {
      label: 'Categorías de comida y tipos de cocina',
    },
  },
  test_restaurant: {
    title: 'Restaurante de prueba',
    description:
      'Convierte este en tu restaurante de prueba para probar impresión, correos, pedidos e integraciones en producción. Sigue funcionando como cualquier otro restaurante y nunca se factura. Solo puedes tener un restaurante de prueba.',
    description_test:
      'Este es tu restaurante de prueba. Funciona como cualquier otro restaurante y nunca se factura. Los correos y SMS a clientes sobre sus pedidos empiezan con [TEST].',
    mark: 'Marcar como restaurante de prueba',
    remove: 'Quitar designación de prueba',
    slot_taken: 'Ya tienes un restaurante de prueba ({{name}}). Quita primero la designación de prueba del existente.',
  },
  buttons: {
    save: 'Guardar',
  },
  toasts: {
    info_updated: 'Configuración actualizada correctamente',
  },
};
